import React from 'react';
import { useTranslation } from 'react-i18next';
import {useIsSandboxMode} from '@/lib/hooks/useIsSandboxMode.js';

const usePaymentPage = () => {
    const { t, i18n } = useTranslation();
    const integrationRef = React.useRef();

    const isSandboxMode = useIsSandboxMode();
    const targetWeezConfig = isSandboxMode ? 'lyriaSandboxUrl' : 'lyriaUrl';
    const lyriaUrl = window.weezConfig?.[targetWeezConfig] ?? 'http://localhost:8003';

    const [displayCallbackBlock, setDisplayCallbackBlock] = React.useState(false);
    const [isPaymentSuccess, setIsPaymentSuccess] = React.useState();
    const [paymentRequestToken, setPaymentRequestToken] = React.useState();
    const [redirectURL, setRedirectURL] = React.useState();
    const [summaryLoading, setSummaryLoading] = React.useState(true);
    const [isTimeUp, setIsTimeUp] = React.useState(false);
    const [order, setOrder] = React.useState(null);
    const [errorCode, setErrorCode] = React.useState(null);
    const [isCredit, setIsCredit] = React.useState(false);
    return {
        t,
        i18n,
        integrationRef,
        lyriaUrl,
        displayCallbackBlock,
        setDisplayCallbackBlock,
        isPaymentSuccess,
        setIsPaymentSuccess,
        paymentRequestToken,
        setPaymentRequestToken,
        redirectURL,
        setRedirectURL,
        summaryLoading,
        setSummaryLoading,
        isTimeUp,
        setIsTimeUp,
        order,
        setOrder,
        errorCode,
        setErrorCode,
        isCredit,
        setIsCredit,
    };
};

export default usePaymentPage;
